module.exports = __webpack_public_path__ + "img/macStep1.5c8f1cf4.png";